import { getSelectedCompanyId } from './selectedCompany';

const running = new Set();
const alreadyRunning = () => new Error('Esta actualización ya está en curso. Espera a que termine antes de volver a enviarla.');

// Web Locks coordinate tabs of this origin. Older browsers still guard double
// submissions in this tab; bulk requests also retain their server idempotency key.
export const withPricingMutationLock = async (scope, work) => {
  const key = `pricing-mutation:${getSelectedCompanyId()}:${scope}`;
  const run = async () => {
    if (running.has(key)) throw alreadyRunning();
    running.add(key);
    try { return await work(); } finally { running.delete(key); }
  };
  if (!navigator.locks?.request) return run();
  return navigator.locks.request(key, { ifAvailable: true }, (lock) => {
    if (!lock) throw alreadyRunning();
    return run();
  });
};

export const requirePricingTargets = (data) => {
  if (!Array.isArray(data?.formatIds) || !data.formatIds.length) {
    throw new Error('Selecciona al menos un formato para actualizar.');
  }
};

export const pricingBatchScope = (branchId, operation, data) => {
  requirePricingTargets(data);
  return `branch:${branchId}:${operation}:${data.formatIds.map(String).sort().join(',')}`;
};
